import { createFileRoute } from '@tanstack/react-router';

import { ResultMapPage } from '@results';

export const Route = createFileRoute('/_app/_admin/results_/$id/map')({
  component: ResultMapPage,
});
